/**
 * Expected mutation failures: guard rails working as intended rather than a degraded
 * experience, so they abort instead of counting against the success rate. Mirrors
 * EXPECTED_CREATE_APPROVAL_ERROR_TYPES in ApprovalsContext, which already decides whether
 * the same error is reported to monitoring.
 *
 * Reasons are a closed set so they stay low-cardinality in SignalFx — never interpolate a
 * contentId, status code or error message into one.
 */
export type ApprovalsWriteAbortReason = 'Access denied' | 'Content not found' | 'Invalid request';

const ABORT_REASON_BY_ERROR_TYPE: Readonly<Record<string, ApprovalsWriteAbortReason>> = {
	ACCESS_DENIED: 'Access denied',
	NOT_FOUND: 'Content not found',
	BAD_REQUEST: 'Invalid request',
};

export const getApprovalsWriteAbortReason = (
	error: unknown,
): ApprovalsWriteAbortReason | undefined => {
	const errorType = (error as { extensions?: { errorType?: string } } | null)?.extensions
		?.errorType;

	return typeof errorType === 'string' ? ABORT_REASON_BY_ERROR_TYPE[errorType] : undefined;
};
